export default "__VITE_ASSET__CpHzJhD8__"